import { useTranslations } from "next-intl";
import { liteClient as algoliasearch } from "algoliasearch/lite";
import { useRouter } from "@lib/i18n/navigation-pages-router";
import { useCloseNavSearch } from "@hooks/use-nav-search-hooks";
import sanitizeString from "@utils/sanitizeString";
import Autocomplete from "./AlgoliaAutocomplete";
import maternityKeywords from "./ressources/maternityKeywords";

const searchClient = algoliasearch(
  process.env.NEXT_PUBLIC_ALGOLIA_APP_ID,
  process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_API_KEY,
);

function AlgoliaSearchBar() {
  const t = useTranslations("common");

  const router = useRouter();
  const closeNavSearch = useCloseNavSearch();

  function shouldAddMaternityKindToQuery(searchString) {
    const sanitizeSearchString = sanitizeString(searchString);
    const maternityKeywordsTranslated = maternityKeywords.map((keyword) =>
      t(`searchBar.${keyword}`),
    );

    return maternityKeywordsTranslated.some((maternityKeyword) =>
      sanitizeSearchString.includes(maternityKeyword),
    );
  }

  function submitSearch(search) {
    closeNavSearch();

    if (shouldAddMaternityKindToQuery(search)) {
      router.push(`/catalogue?search=${search}&kinds[]=maternity`);
    } else {
      router.push(`/catalogue?search=${search}`);
    }
  }

  return (
    <div className="algolia-search-container flex-grow-1">
      <div className="flex-grow-1">
        <Autocomplete
          submitSearch={submitSearch}
          searchClient={searchClient}
        />
      </div>
    </div>
  );
}

export default AlgoliaSearchBar;
